import { mapFields } from'vuex-map-fields';
import { validateAttachment, uploadAttachment } from '~/api'
import swal from "sweetalert2";
import { mapActions } from 'vuex';
import { values } from 'lodash';

export default {
	data: () => ({
		formFiles: {
			ui: {
				loading: false
			}
		}
	}),

	computed: {
		...mapFields('details', [
			'record',
			'files'
		])
	},

	methods: {

		...mapActions('details', {
			setFormFieldErrors: "setFormFieldErrors",
			markFormFieldAsValidated: "markFormFieldAsValidated"
		}),

		areThereUploadFiles() {
			return true
		},

		hasAttachmentsFilesToValidate() {
			return _.some(this.files, (value, key) => {
				return value.file && !value.validated
			})
		},

		hasAttachmentsFilesToUpload() {
			return _.some(this.files, (value, key) => {
				return value.file
			})
		},

		hasAttachmentsErrors() {
			return _.some(this.files, (value, key) => {
				return value.errors
			})
		},

		validateAttachments() {
			return new Promise(async (resolve, reject) => {
				if (!this.hasAttachmentsFilesToValidate()) {
					return resolve();
				}

				this.formFiles.ui.loading = true;

				for (const key in this.files) {
					let value = this.files[key];
					let field = key;
					let file = value.file
					try {
						if (field && file && !value.validated) {

							let formData = new FormData();

							formData.append('parentId', this.record.Id)

							if (field) {
								formData.append('field', field)
							}

							if (file) {
								formData.append('file', file)
							}

							await validateAttachment(formData);
							this.markFormFieldAsValidated(field)
						}
					} catch (e) {

						console.error(e)

						this.setFormFieldErrors({
							field: field,
							errors: e.errors
						})

						await new Promise(resolve => setTimeout(resolve, 1500));

						this.focus(field);

						this.formFiles.ui.loading = false;

						return reject(e)
					}
				}

				setTimeout(() => {
					this.formFiles.ui.loading = false;
					resolve();
				}, 3000);

				/*

				swal.queue([{
					title: 'Validating attachments',
					showConfirmButton: false,
					onOpen: async () => {
						for (const key in this.files) {
							let value = this.files[key];
							let field = key;
							let file = value.file
							try {
								if (field && file && !value.validated) {
									swal.update({
										title: "Validating " + _.startCase(field)
									});

									let formData = new FormData();

									formData.append('parentId', this.record.Id)

									if (field) {
										formData.append('field', field)
									}

									if (file) {
										formData.append('file', file)
									}

									await validateAttachment(formData);
									this.markFormFieldAsValidated(field)
								}
							} catch (e) {

								console.error(e)

								this.setFormFieldErrors({
									field: field,
									errors: e.errors
								})

								swal.update({
									title: "Please, review the following file: " + _.startCase(field),
									type: 'error',
								})

								await new Promise(resolve => setTimeout(resolve, 3000));

								swal.close()

								this.focus(field);

								return reject(e)
							}
						}

						swal.update({
							type: 'success',
							title: 'Files successfully validated'
						})
						setTimeout(() => {
							swal.close()
							resolve();
						}, 3000);
					}
				}])
				*/
			});
		},

		async uploadAttachments() {
			return new Promise(async (resolve, reject) => {
				if (!this.hasAttachmentsFilesToUpload()) {
					return resolve();
				}

				this.formFiles.ui.loading = true;

				for (const key in this.files) {
					let value = this.files[key];
					let field = key;
					let file = value.file
					try {
						if (field && file) {
							let formData = new FormData();

							formData.append('parentId', this.record.Id)

							if (field) {
								formData.append('field', field)
							}

							if (file) {
								formData.append('file', file)
							}

							if (!value.validated) {

								await validateAttachment(formData)

								this.markFormFieldAsValidated(field)
							}

							await uploadAttachment(formData)
						}
					} catch (e) {

						this.setFormFieldErrors({
							field: field,
							errors: e.errors
						})

						await new Promise(resolve => setTimeout(resolve, 1500));

						this.focus(field);

						this.formFiles.ui.loading = false;

						reject(e)
					}
				}

				setTimeout(() => {
					this.formFiles.ui.loading = false;
					resolve();
				}, 3000);

				/*

				swal.queue([{
					title: 'Validating attachments',
					showConfirmButton: false,
					onOpen: async () => {
						for (const key in this.files) {
							let value = this.files[key];
							let field = key;
							let file = value.file
							try {
								if (field && file) {
									let formData = new FormData();

									formData.append('parentId', this.record.Id)

									if (field) {
										formData.append('field', field)
									}

									if (file) {
										formData.append('file', file)
									}

									if (!value.validated) {
										swal.update({
											title: "Validating " + _.startCase(field)
										});

										await validateAttachment(formData)

										this.markFormFieldAsValidated(field)
									}

									swal.update({
										title: "Uploading " + _.startCase(field)
									});
									await uploadAttachment(formData)
								}
							} catch (e) {

								this.setFormFieldErrors({
									field: field,
									errors: e.errors
								})

								swal.update({
									title: "Please, review the following file:" + _.startCase(field),
									type: 'error',
								})

								await new Promise(resolve => setTimeout(resolve, 3000));

								swal.close()

								this.focus(field);

								reject(e)
							}
						}

						swal.update({
							type: 'success',
							title: 'Files successfully uploaded.'
						})
						setTimeout(() => {
							swal.close()
							resolve();
						}, 3000);
					}
				}])
				*/
			});
		},

		focus(field) {
			field = _.split(field, ".");
			field = field[0];
			$(`#${field}`).blur();
			$(`#${field}`).focus();
		},
	}
}



// WEBPACK FOOTER //
// ./resources/js/mixins/fileUpload.js